import { AppointmentType } from 'kb-shared/types';

export const ONLINE_BOOKING_UNAVAILABLE_PHONE_NUMBER = '855-563-2639';
export const ONLINE_BOOKING_UNAVAILABLE_PHONE_HREF = `tel://${ONLINE_BOOKING_UNAVAILABLE_PHONE_NUMBER}`;
export const ONLINE_BOOKING_UNAVAILABLE_MESSAGE =
  'Self-scheduling is currently unavailable for this market. Please call us to schedule at';

export const isOnlineBookingUnavailableForAppointmentType = ({
  appointmentType
}: {
  appointmentType?: AppointmentType | null;
}) => Boolean(appointmentType?.disableOnlineBooking);
